document.addEventListener( 'DOMContentLoaded', function () {
	const accordionDetails = document.querySelectorAll( '.accordion-details' );
	// Exit early if no .accordion-details elements are found
	if ( accordionDetails.length === 0 ) return;
	accordionDetails && accordionDetails.forEach( details => {
		details.addEventListener( 'toggle', function( event ) {
			if ( this.hasAttribute('open') ) {
				this.querySelector('summary').setAttribute('aria-expanded', true);
			} else {
				this.querySelector('summary').setAttribute('aria-expanded', false);
			}
		} );
	} );
} );